import { create } from 'zustand'

import type { User } from '@/features/auth/types'

interface AuthState {
  user: User | null
  accessToken: string | null
  isAuthenticated: boolean
  setAuth: (user: User, token: string) => void
  clearAuth: () => void
  setUser: (user: User) => void
}

export const useAuthStore = create<AuthState>()((set) => ({
  user: null,
  accessToken: null,
  isAuthenticated: false,
  setAuth: (user: User, token: string) => {
    set({ user, accessToken: token, isAuthenticated: true })
  },
  clearAuth: () => {
    set({ user: null, accessToken: null, isAuthenticated: false })
  },
  setUser: (user: User) => {
    set({ user })
  },
}))
